import RewardAdvancedView from './RewardAdvancedView'

export default RewardAdvancedView
